<template>
    <section>
        <the-navbar />
        <router-view></router-view>
    </section>
</template>

<script>
import PageLoader from '@/components/shared/PageLoader';
import TheNavbar from '@/components/shared/Layout/TheNavbar.vue';
import TheFooter from '../components/shared/Layout/TheFooter.vue';

export default {
    name: 'User',
    metaInfo: {
        title: 'Inicio',
    },
    components: {
        PageLoader,
        TheNavbar,
        TheFooter,
    },
    data() {
        return {
            displayLoader: false,
        };
    },
    async mounted() {
        /* if (!this.currentToken) {
            await this.$router.push('/login');
        } else {
            this.displayLoader = true;
            try {
                const result = await this.$store.dispatch('me/get');

                switch (result.perfil.descripcion) {
                    case "Empleado":
                        break;
                    case "Recursos Humanos":
                        await this.$router.push('/a');
                        break;
                    default:
                        await this.$router.push('/account');
                        break;
                }
            } catch (e) {
                await this.$store.dispatch('auth/logout');
                await this.$router.push('/login');
            } finally {
                this.displayLoader = false;
            }
        } */
    },
    computed: {
        currentToken() {
            return this.$store.state.auth.token;
        },
        perfil() {
            return this.$store.state.me.perfil;
        },
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
    },
};
</script>

<style>
</style>
